import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_reviewupdate_policies_and_procedures_written_or_in'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_reviewupdate_policies_and_procedures_written_or_in',
  name: 'Does the facility review/update policies and procedures (written or informal)?',
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'RECRUITMENT_AND_HIRING',
      text: 'Recruitment and hiring',
      externalIds: [
        {
          id: 'ms-6--2-1x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please describe how often (or when) the policies and procedures are reviewed/updated:',
        externalIds: [
          {
            id: 'ms-6--2-1f',
            version: '1.3',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'TERMINATION_AND_RETRENCHMENT',
      text: 'Termination and retrenchment',
      externalIds: [
        {
          id: 'ms-6--2-2x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please describe how often (or when) the policies and procedures are reviewed/updated:',
        externalIds: [
          {
            id: 'ms-6--2-2f',
            version: '1.3',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'FACILITY_WORKPLACE_RULES',
      text: 'Facility workplace rules',
      externalIds: [
        {
          id: 'ms-6--2-3x',
          version: '1.3',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please describe how often (or when) the policies and procedures are reviewed/updated:',
        externalIds: [
          {
            id: 'ms-6--2-3f',
            version: '1.3',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'CHILD_LABOR_AND_YOUNG_WORKERS',
      text: 'Child labor and young workers',
      externalIds: [
        {
          id: 'ms-6--2-4x',
          version: '1.3',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please describe how often (or when) the policies and procedures are reviewed/updated:',
        externalIds: [
          {
            id: 'ms-6--2-4f',
            version: '1.3',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'PROHIBITION_OF_FORCED_LABOR',
      text: 'Prohibition of forced labor',
      externalIds: [
        {
          id: 'ms-6--2-5x',
          version: '1.3',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please describe how often (or when) the policies and procedures are reviewed/updated:',
        externalIds: [
          {
            id: 'ms-6--2-5f',
            version: '1.3',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'ANTI_HARASSMENT_AND_ABUSE',
      text: 'Anti-harassment and abuse',
      externalIds: [
        {
          id: 'ms-6--2-6x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please describe how often (or when) the policies and procedures are reviewed/updated:',
        externalIds: [
          {
            id: 'ms-6--2-6f',
            version: '1.3',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'ANTI_DISCRIMINATION',
      text: 'Anti-discrimination',
      externalIds: [
        {
          id: 'ms-6--2-7x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please describe how often (or when) the policies and procedures are reviewed/updated:',
        externalIds: [
          {
            id: 'ms-6--2-7f',
            version: '1.3',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'WORKING_HOURS',
      text: 'Working Hours',
      externalIds: [
        {
          id: 'ms-6--2-8x',
          version: '1.3',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please describe how often (or when) the policies and procedures are reviewed/updated:',
        externalIds: [
          {
            id: 'ms-6--2-8f',
            version: '1.3',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'WAGES_AND_BENEFITS',
      text: 'Wages and Benefits',
      externalIds: [
        {
          id: 'ms-6--2-9x',
          version: '1.3',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please describe how often (or when) the policies and procedures are reviewed/updated:',
        externalIds: [
          {
            id: 'ms-6--2-9f',
            version: '1.3',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'DISCIPLINE',
      text: 'Discipline',
      externalIds: [
        {
          id: 'ms-6--2-10x',
          version: 1.3,
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please describe how often (or when) the policies and procedures are reviewed/updated:',
        externalIds: [
          {
            id: 'ms-6--2-10f',
            version: 1.3,
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'FREEDOM_OF_ASSOCIATION_AND_COLLECTIVE_BARGAINING',
      text: 'Freedom of association and collective bargaining',
      externalIds: [
        {
          id: 'ms-6--2-11x',
          version: '1.3',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please describe how often (or when) the policies and procedures are reviewed/updated:',
        externalIds: [
          {
            id: 'ms-6--2-11f',
            version: '1.3',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'GRIEVANCE_SYSTEMS',
      text: 'Grievance systems',
      externalIds: [
        {
          id: 'ms-6--2-12x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please describe how often (or when) the policies and procedures are reviewed/updated:',
        externalIds: [
          {
            id: 'ms-6--2-12f',
            version: '1.3',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'WORKER_FEEDBACK',
      text: 'Worker Feedback',
      externalIds: [
        {
          id: 'ms-6--2-13x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please describe how often (or when) the policies and procedures are reviewed/updated:',
        externalIds: [
          {
            id: 'ms-6--2-13f',
            version: '1.3',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'HEALTH_AND_SAFETY',
      text: 'Health and safety',
      externalIds: [
        {
          id: 'ms-6--2-14x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please describe how often (or when) the policies and procedures are reviewed/updated:',
        externalIds: [
          {
            id: 'ms-6--2-14f',
            version: '1.3',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'FOREIGN_MIGRANT_WORKERS',
      text: 'Foreign migrant workers',
      externalIds: [
        {
          id: 'ms-che-4x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please describe how often (or when) the policies and procedures are reviewed/updated:',
        externalIds: [
          {
            id: 'ms-che-5f',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'DOMESTIC_MIGRANT_WORKERS',
      text: 'Domestic migrant workers',
      externalIds: [
        {
          id: 'ms-che-6x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please describe how often (or when) the policies and procedures are reviewed/updated:',
        externalIds: [
          {
            id: 'ms-che-7f',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'HOMEWORKERS',
      text: 'Homeworkers',
      externalIds: [
        {
          id: 'ms-6--2-17x',
          version: '1.3',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please describe how often (or when) the policies and procedures are reviewed/updated:',
        externalIds: [
          {
            id: 'ms-6--2-17f',
            version: '1.3',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'SUPPLIERS_SUBCONTRACTORS',
      text: 'Suppliers/subcontractors',
      externalIds: [
        {
          id: 'ms-6--2-18x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please describe how often (or when) the policies and procedures are reviewed/updated:',
        externalIds: [
          {
            id: 'ms-6--2-18f',
            version: '1.3',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'RAW_MATERIALS_SOURCING',
      text: 'Raw materials sourcing',
      externalIds: [
        {
          id: 'ms-che-8x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please describe how often (or when) the policies and procedures are reviewed/updated:',
        externalIds: [
          {
            id: 'ms-che-9f',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'BRIBERY_AND_ANTI_CORRUPTION',
      text: 'Bribery and anti-corruption',
      externalIds: [
        {
          id: 'ms-6--2-19x',
          version: '1.3',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please describe how often (or when) the policies and procedures are reviewed/updated:',
        externalIds: [
          {
            id: 'ms-6--2-19f',
            version: '1.3',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'OTHER',
      text: 'Other',
      externalIds: [
        {
          id: 'ms-6--2-20x',
          version: 1.3,
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'If other, please describe:',
        externalIds: [
          {
            id: 'ms-6--2-20f',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'RECRUITMENT_AND_HIRING',
                'TERMINATION_AND_RETRENCHMENT',
                'FACILITY_WORKPLACE_RULES',
                'CHILD_LABOR_AND_YOUNG_WORKERS',
                'PROHIBITION_OF_FORCED_LABOR',
                'ANTI_HARASSMENT_AND_ABUSE',
                'ANTI_DISCRIMINATION',
                'WORKING_HOURS',
                'WAGES_AND_BENEFITS',
                'DISCIPLINE',
                'FREEDOM_OF_ASSOCIATION_AND_COLLECTIVE_BARGAINING',
                'GRIEVANCE_SYSTEMS',
                'WORKER_FEEDBACK',
                'HEALTH_AND_SAFETY',
                'FOREIGN_MIGRANT_WORKERS',
                'DOMESTIC_MIGRANT_WORKERS',
                'HOMEWORKERS',
                'SUPPLIERS_SUBCONTRACTORS',
                'RAW_MATERIALS_SOURCING',
                'BRIBERY_AND_ANTI_CORRUPTION',
                'OTHER',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'ms-che-3',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 23350,
  sectionId: '2.2.6.12',
  impactArea: 'Management Systems',
  impactAreaId: 'MANAGEMENT_SYSTEMS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
